// import React from 'react'

export default props => {
    if (props.testArgOneOr !== undefined) {
        if (props.testArgOneOr || props.testArgTwoOr) {
            return props.children
        } else {
            return false
        }
    }
    else {
        if (props.test) {
            return props.children
        } else {
            return false
        }

    }
}